import styled from 'styled-components'
import { Card, Heading, Text, Button as RButton } from 'rebass'
import Checkbox from './checkbox'
export { Checkbox }

export const H = styled(Heading)`
  color: white;
  margin-bottom: 4%;
  text-align: center;
  font-variant: small-caps;
`
export const P = styled(Text)`
  color: white;
`

export const Input = styled.input`
  outline: none;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  margin-bottom: 4%;
  border: 1px solid ${props => props.hasError ? '#f00' : '#ccc'};
  ${props => props.hasError ? 'box-shadow: 0 0 5px #f00;' : ''}
  padding: 3%;
  color: #555;
  font: 95% Arial, Helvetica, sans-serif;

  :focus {
    box-shadow: 0 0 5px #5043D1;
    padding: 3%;
    border: 1px solid #5043D1;
  }
`

export const Button = styled(RButton)`
  width: 100%;
  padding: 3%;
  background: #09840F;
	border-bottom: 2px solid #0C540F;
	border-top-style: none;
	border-right-style: none;
	border-left-style: none;	
  color: #fff;
  
  :hover {
    background: #1DAD23;
  }
`

export const StatusContainer = styled(Card)`
  padding: 2% 0%;
  text-align: center;
  margin: auto;
`